export const UPGRADE_COMMON_LABELS = {
  arm: 'ARM fw. version',
  dspm: 'DSPM fw. version',
  dsps: 'DSPS fw. version',
  cancel: 'Cancel',
  confirm: 'Confirm',
  close: 'Close',
  actions: 'Actions',
  country: 'Country',
  region: 'Region',
  version: 'Version',
  currentVersion: 'Current Version',
  latestVersion: 'Latest Version',
  module: 'Module',
  filter: 'Filter',
  noSafety: 'No safety',
  confirmTitle: 'Update Confirmation',
  upgradeSafetyConfirmMessage: 'Are you sure you want to upgrade the safety file country {country} , region {region} and version {version}?',
  upgradingSafety: 'Upgrading safety file...',
} as const;

export type UpgradeCommonLabels = typeof UPGRADE_COMMON_LABELS;
